module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/3/5-68849dc76fd51a9bc9a2dec3e80599c9.jpg";